var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 4.58333C6.3555 4.58333 5.83317 4.061 5.83317 3.41667C5.83317 2.77233 6.3555 2.25 6.99984 2.25C7.64417 2.25 8.1665 2.77233 8.1665 3.41667C8.1665 4.061 7.64417 4.58333 6.99984 4.58333Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 8.66667C6.3555 8.66667 5.83317 8.14433 5.83317 7.5C5.83317 6.85567 6.3555 6.33333 6.99984 6.33333C7.64417 6.33333 8.1665 6.85567 8.1665 7.5C8.1665 8.14433 7.64417 8.66667 6.99984 8.66667Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 12.75C6.3555 12.75 5.83317 12.2277 5.83317 11.5833C5.83317 10.939 6.3555 10.4167 6.99984 10.4167C7.64417 10.4167 8.1665 10.939 8.1665 11.5833C8.1665 12.2277 7.64417 12.75 6.99984 12.75Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/menuDots.d403744b27c289eb2255b6e9b2fd45a6.svg";
export { ForwardRef as ReactComponent };